<mom-button :disabled="disabled" @click.native="blurButton" :variant="variant" ref="button" class="progress-button">
    <slot></slot>
    <template v-if="showProgress">
        <div class="progress-button__surface"></div>
        <div class="progress-button__bar">
            <div class="progress-button__buffer"></div>
        </div>
    </template>
</mom-button>
